import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconDefinition, faClose } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'mom-header-with-close-button',
  templateUrl: './header-with-close-button.component.html',
  styleUrls: ['./header-with-close-button.component.scss']
})
export class HeaderWithCloseButtonComponent {
  @Input() cssClass: string;
  @Input() icon: IconDefinition = faClose;
  @Output() closePage = new EventEmitter<void>();
}
